export default __webpack_public_path__ + "static/media/read-flag.7a9b87be.svg";